// extracted by mini-css-extract-plugin
export default {"topSection":"styles_topSection__sJuEX","topSection__dateLabel":"styles_topSection__dateLabel__6Pi1S"};